import {TrackableEntity} from '../data/ChangeTrackable';
import { IDictionary } from '../data/TrackingModule';
import { DBMappingInfo } from '../../framework.core/data/DBMappingInfo';

export class PimsContainer extends TrackableEntity {
    id: number = 0;
    bookingId: number = 0;
    cntrNo: string = '';
    cntrType: string = '';
    sealNo1: string = '';
    sealNo2: string = '';
    pickupNo: string = '';
    airId: number = 0;
    estWeight: number = 0;
    estWeightUnit: string = '';
    createdBy: string = '';
    createdAt: string = '';
    updatedBy: string = '';
    updatedAt: string = '';
    lastMSDesc: string = '';
    msBooking: string | null = null;
    msPickup: string | null = null;
    msOriginReceipt: string | null = null;
    msLoadedOnVessel: string | null = null;
    msShipDeparture: string | null = null;
    msCarrierReleased: string | null = null;
    msCustomsReleased: string | null = null;
    msShipArrival: string | null = null;
    msUnLoadedFromVessel: string | null = null;
    msDeliveryCFS: string | null = null;
    msRailDeparture: string | null = null;
    msRailArrival: string | null = null;
    msAvailablePickup: string | null = null;
    msPickupDelivery: string | null = null;
    msDeliveryCustomer: string | null = null;
    msEmptyCntrRtn: string | null = null;
    locBooking: string = '';
    locContainerDispatched: string = '';
    locInGate: string = '';
    locLoadedOnVessel: string = '';
    locVesselDeparture: string = '';
    locCarrierReleased: string = '';
    locCustomsReleased: string = '';
    locVesselArrival: string = '';
    locUnLoadedFromVessel: string = '';
    locDeliveryCFS: string = '';
    locRailDeparture: string = '';
    locRailArrival: string = '';
    locAvailablePickup: string = '';
    locOutGate: string = '';
    locDeliveryCustomer: string = '';
    locEmptyCntrRtn: string = '';
    mCntrId: number = 0;
    hCntrId: number = 0;
    kgs: number = 0;
    lbs: number = 0;
    cbm: number = 0;
    cft: number = 0;
    shipQty: number = 0;

    constructor(init?:Partial<PimsContainer>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'bookingId', 'cntrNo', 'cntrType', 'sealNo1', 'sealNo2', 'estWeight', 'estWeightUnit', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'lastMSIndex', 'lastMSDesc', 'totQty', 'mCntrId', 'hCntrId', 'kgs', 'lbs', 'cbm', 'cft', 'shipQty');
        this.getdateProps.push('createdAt', 'updatedAt'); 
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(isAir:boolean):IDictionary<DBMappingInfo> {
        return PimsContainer.getFieldMappings(isAir);
    }

    static _seaDicFieldMappings:IDictionary<DBMappingInfo> = {
        'pickupNo': new DBMappingInfo({ field: 'f_pickupno', table: '@TbName' }),
        'msBooking': new DBMappingInfo({ field: 'f_bookingdate', table: '@TbName' }),
        'msPickup': new DBMappingInfo({ field: 'f_ord', table: '@TbName' }),
        'msOriginReceipt': new DBMappingInfo({ field: 'f_indate', table: '@TbName' }),
        'msLoadedOnVessel': new DBMappingInfo({ field: 'f_loaddate', table: '@TbName' }),
        'msShipDeparture': new DBMappingInfo({ field: 'f_atd', table: '@TbName' }),
        'msCarrierReleased': new DBMappingInfo({ field: 'f_carrierrls', table: '@TbName' }),
        'msCustomsReleased': new DBMappingInfo({ field: 'f_customrls', table: '@TbName' }),
        'msShipArrival': new DBMappingInfo({ field: 'f_ata', table: '@TbName' }),
        'msUnLoadedFromVessel': new DBMappingInfo({ field: 'f_unloaddate', table: '@TbName' }),
        'msDeliveryCFS': new DBMappingInfo({ field: 'f_cfsdate', table: '@TbName' }),
        'msRailDeparture': new DBMappingInfo({ field: 'f_ratd', table: '@TbName' }),
        'msRailArrival': new DBMappingInfo({ field: 'f_rata', table: '@TbName' }),
        'msAvailablePickup': new DBMappingInfo({ field: 'f_pudate', table: '@TbName' }),
        'msPickupDelivery': new DBMappingInfo({ field: 'f_outdate', table: '@TbName' }),
        'msDeliveryCustomer': new DBMappingInfo({ field: 'f_dcdate', table: '@TbName' }),
        'msEmptyCntrRtn': new DBMappingInfo({ field: 'f_emptyreturn', table: '@TbName' }),
        'locBooking': new DBMappingInfo({ field: 'f_booking_loc', table: '@TbName' }),
        'locContainerDispatched': new DBMappingInfo({ field: 'f_ord_loc', table: '@TbName' }),
        'locInGate': new DBMappingInfo({ field: 'f_indate_loc', table: '@TbName' }),
        'locLoadedOnVessel': new DBMappingInfo({ field: 'f_loaddate_loc', table: '@TbName' }),
        'locVesselDeparture': new DBMappingInfo({ field: 'f_atd_loc', table: '@TbName' }),
        'locCarrierReleased': new DBMappingInfo({ field: 'f_carrierrls_loc', table: '@TbName' }),
        'locCustomsReleased': new DBMappingInfo({ field: 'f_customrls_loc', table: '@TbName' }),
        'locVesselArrival': new DBMappingInfo({ field: 'f_ata_loc', table: '@TbName' }),
        'locUnLoadedFromVessel': new DBMappingInfo({ field: 'f_unloaddate_loc', table: '@TbName' }),
        'locDeliveryCFS': new DBMappingInfo({ field: 'f_cfsdate_loc', table: '@TbName' }),
        'locRailDeparture': new DBMappingInfo({ field: 'f_ratd_loc', table: '@TbName' }),
        'locRailArrival': new DBMappingInfo({ field: 'f_rata_loc', table: '@TbName' }),
        'locAvailablePickup': new DBMappingInfo({ field: 'f_pudate_loc', table: '@TbName' }),
        'locOutGate': new DBMappingInfo({ field: 'f_outdate_loc', table: '@TbName' }),
        'locDeliveryCustomer': new DBMappingInfo({ field: 'f_dcdate_loc', table: '@TbName' }),
        'locEmptyCntrRtn': new DBMappingInfo({ field: 'f_emptyreturn_loc', table: '@TbName' }),
        'mCntrId': new DBMappingInfo({ field: 'f_id', table: '@TbName' }),
        'id': new DBMappingInfo({ field: 'F_PIMSLINKID', table: '@TbName' }),

    };

    static _airDicFieldMappings:IDictionary<DBMappingInfo> = {
        'pickupNo': new DBMappingInfo({ field: 'f_pickupno', table: '@TbName' }),
        'msPickup': new DBMappingInfo({ field: 'f_pickupdate', table: '@TbName' }),
        'msShipDeparture': new DBMappingInfo({ field: 'f_atd', table: '@TbName' }),
        'msCustomsReleased': new DBMappingInfo({ field: 'f_customrls', table: '@TbName' }),
        'msShipArrival': new DBMappingInfo({ field: 'f_ata', table: '@TbName' }),
        'msAvailablePickup': new DBMappingInfo({ field: 'f_avail', table: '@TbName' }),
        'msDeliveryCustomer': new DBMappingInfo({ field: 'f_delivery', table: '@TbName' }),
        'locContainerDispatched': new DBMappingInfo({ field: 'f_pickuploc', table: '@TbName' }),
        'locVesselDeparture': new DBMappingInfo({ field: 'f_atdloc', table: '@TbName' }),
        'locCustomsReleased': new DBMappingInfo({ field: 'f_custmrlsloc', table: '@TbName' }),
        'locVesselArrival': new DBMappingInfo({ field: 'f_ataloc', table: '@TbName' }),
        'locAvailablePickup': new DBMappingInfo({ field: 'f_availloc', table: '@TbName' }),
        'locDeliveryCustomer': new DBMappingInfo({ field: 'f_delvloc', table: '@TbName' }),
        'id': new DBMappingInfo({ field: 'F_Id', table: '@TbName' }),

    };

    // Called from View to make SQLList by passing arg
    static getFieldMappings = (isAir:boolean):IDictionary<DBMappingInfo> => {
        if(isAir) return this._airDicFieldMappings;
        else return this._seaDicFieldMappings;
    };
}
